import { getParameters } from "../common";

export class WatermarkOverlay {
    private watermarkOverlay = document.getElementById("watermark-overlay");
    private watermarkData = document.getElementById("watermark-data");

    constructor() {
        if (!this.watermarkOverlay || !this.watermarkData) {
            throw new Error("Watermark overlay not found");
        }
        const { watermark } = getParameters();
        if (!watermark?.length) {
            this.watermarkOverlay.style.display = "none";
        } else {
            for (const line of watermark) {
                const newDiv = document.createElement("div");
                newDiv.innerText = line;
                this.watermarkData.appendChild(newDiv);
            }
        }
    }
}
